import { useEffect } from "react";
import Lenis from "lenis";
import { useLocation } from "react-router-dom";
import { useMotionPref } from "@/context/MotionPref";

let lenisInstance = null;

export const scrollToTop = (immediate = true) => {
  if (lenisInstance) lenisInstance.scrollTo(0, { immediate });
  else window.scrollTo(0, 0);
};

export default function SmoothScroll({ children }) {
  const location = useLocation();
  const { paused } = useMotionPref();

  useEffect(() => {
    if (paused) return undefined;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
      touchMultiplier: 1.6,
    });
    lenisInstance = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisInstance = null;
    };
  }, [paused]);

  // reset scroll on route change
  useEffect(() => {
    scrollToTop(true);
  }, [location.pathname]);

  return children;
}
